import type { PrepayPayment } from "~/shared/schemas/prepay-notification-schema.ts";
import type { QuoteResponse } from "~/shared/schemas/quote-schema.ts";
import type {
	PaymentNonce,
	SavedAch,
	SavedCard,
} from "~/shared/types/payment-types.ts";

export type SelectedPaymentMethod = SavedCard | SavedAch | PaymentNonce;

export const isAchMethod = (paymentMethod: SelectedPaymentMethod): boolean => {
	if (paymentMethod.paymentMethod === "ACH") return true;
	return "accountType" in paymentMethod && Boolean(paymentMethod.accountType);
};

export const getMethodLastFour = (
	paymentMethod: SelectedPaymentMethod,
): string => paymentMethod.Last4 ?? "";

export const getMethodAccountType = (
	paymentMethod: SelectedPaymentMethod,
): string => {
	if ("accountType" in paymentMethod && paymentMethod.accountType) {
		return paymentMethod.accountType;
	}
	if ("cardType" in paymentMethod && paymentMethod.cardType) {
		return paymentMethod.cardType;
	}
	return isAchMethod(paymentMethod) ? "ACH" : "CreditCard";
};

export const buildPrepayPayment = (
	paymentMethod: SelectedPaymentMethod,
	quote: QuoteResponse,
	amount: number,
	notes: string,
	confirmationNumber: string,
): PrepayPayment => ({
	accountType: getMethodAccountType(paymentMethod),
	isLumpSum: true,
	confirmationNumber,
	lastFour: getMethodLastFour(paymentMethod),
	amountPaid: amount.toString(),
	comments: notes,
	tqlPos: [String(quote.poNumber ?? "")],
});
